import { RemarketingData } from 'autogen/swagger/all';
import { useEffect } from 'react';

let hasRunOnce = false;

export default function usePushRemarketingDataOnce(remarketingData: RemarketingData) {
    useEffect(() => {
        if (!hasRunOnce) {
            hasRunOnce = true;
            window.dataLayer?.push(remarketingData);
        }
    }, [remarketingData]);

    return null;
}
